import React from 'react'
import styled from 'styled-components'

import GA4 from 'helpers/ga4'
import Checkbox from 'components/Checkbox'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Tooltip from 'components/Tooltip'
import KeyboardAccessible from 'components/KeyboardAccessible'

interface Alerts {
  criticalAlerts: boolean
  majorAlerts: boolean
  criticalSdaAlerts: boolean
  majorSdaAlerts: boolean
  companyUpdateAlerts: boolean
  dailyDigestCriticalAlerts: boolean
  dailyDigestMajorAlerts: boolean
  dailyDigestCriticalSdaAlerts: boolean
  dailyDigestMajorSdaAlerts: boolean
}

interface AlertType {
  title: string
  checked: boolean
  description: string
  name: keyof Alerts
}

interface AlertNotificationCheckboxListProps {
  alertTypes: AlertType[]
  alerts: Alerts
  setAlerts: (alerts: Alerts) => void
}

const AlertNotificationCheckboxList: React.FC<AlertNotificationCheckboxListProps> = ({ alertTypes, alerts, setAlerts }) => {
  const handleChange = (alertType: AlertType) => {
    setAlerts({ ...alerts, [alertType.name]: !alertType.checked })

    if (alertType.name.startsWith('dailyDigest')) {
      const selectedAfterToggle = alertTypes.filter(t =>
        t.name === alertType.name ? !t.checked : t.checked
      )

      if (selectedAfterToggle.length > 0) {
        GA4.sendEvent({
          category: 'Notification Recipient Page',
          action: 'Daily Email Digest Enabled',
          label: `Alert Type(s) selected: ${selectedAfterToggle.map(t => t.title).join(', ')}`
        })
      } else {
        GA4.sendEvent({
          category: 'Notification Recipient Page',
          action: 'Daily Email Digest Disabled',
          label: 'Daily Email Digest Disabled'
        })
      }
    }
  }

  return (
    <div>
      {alertTypes.map((alertType) => (
        <S.AlertNotificationCheckbox key={alertType.title}>
          <Checkbox
            listId={alertType.name}
            label={`${alertType.title} Alerts`}
            onChange={() => handleChange(alertType)}
            checked={alertType.checked}
          />
          <Tooltip title={alertType.description}>
            <S.InfoIcon readOnly>
              <InfoOutlinedIcon />
            </S.InfoIcon>
          </Tooltip>
        </S.AlertNotificationCheckbox>
      ))}
    </div>
  )
}

export default AlertNotificationCheckboxList

const S = {
  AlertNotificationCheckbox: styled.div`
    display: flex;
    align-items: center;
  `,
  InfoIcon: styled(KeyboardAccessible)`
    margin: -6px 0 0 7px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 20px;
      height: 20px;
    }
  `
}
